module.exports = __webpack_public_path__ + "static/media/tab_Group39.cdc2c7b5.png";